//Ordenes de compra y solicitudes Repositorio
export const oldOrdersAdapter = (response) => {
    if (!response || !Array.isArray(response.purchase_orders)) {
        console.warn('⚠️ Estructura inesperada en respuesta:', response);
        return {
            orders: [],
            erpPaId: null,
        };
    }
    const ordersAdapted = response.purchase_orders.map((order) => ({
        id: order.id,
        name: order.name,
        dateOrder: order.date_order || '-',
        type: order.type ?? '-',
        state: order.state || '-',
        ref: order.ref || '-',
        company: order.company || '-',
        responsible: order.responsible || '-',
        amount: order.amount ?? 0,
        currency: order.currency || 'USD',
        activityDate: order.activity_date || '-',
        paymentDate: order.payment_date || '-',
        effectiveDateOfPayment: order.effective_date_of_payment || '-',
        payOrder: order.pay_order || '-',
        typeId: order.type_id ?? null,
        typeIdName: order.type_id_name || '-',
        notes: order.notes || '-',
    }));

    return {
        orders: ordersAdapted,
        erpPaId: response.erp_pa_id ?? null,
    };
};
